<template></template>

<script>
  export default {
    name: 'cdr-client',
    methods: {
      api_url: function (path, id = '') {
        return `${process.env.CDR_API}${path}`.replace('{id}', `${id}`)
      },
      api_options: function (fileUploads = false) {
        if (fileUploads) {
          return {
            headers: {
              'token': localStorage.getItem('fonestorm-token')
            },
            mode: 'no-cors',
            credentials: 'include'
          }
        } else {
          return {
            dataType: 'json',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'token': localStorage.getItem('fonestorm-token')
            },
            mode: 'no-cors',
            credentials: 'include'
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/fractel/clients/CDR/CDR.vue